function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { usePrevProp, useRefCallback } from '@bydesign-ui/hooks';
import { classnames, shallowEqual } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { RcMenu } from '../../hooks/menu';
import { RcPopper } from '../../hooks/popper';
import { ItemGroup } from './components/ItemGroup';
import { MenuItem } from './components/MenuItem';
import { SubMenu } from './components/SubMenu';
export function Menu(props) {
  var openIds = props.openIds,
      _props$collapse = props.collapse,
      collapse = _props$collapse === void 0 ? false : _props$collapse,
      _props$showLine = props.showLine,
      showLine = _props$showLine === void 0 ? false : _props$showLine,
      children = props.children,
      style = props.style,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'light' : _props$theme,
      onOpenChange = props.onOpenChange,
      onClick = props.onClick,
      className = props.className,
      rest = _objectWithoutProperties(props, ["openIds", "collapse", "showLine", "children", "style", "theme", "onOpenChange", "onClick", "className"]);

  var extraProps = {
    theme: theme,
    collapse: collapse,
    showLine: showLine
  };
  var menuType = collapse ? 'collapse' : 'uncollapse';
  var openIdsProp = collapse ? [] : openIds;

  var _useState = useState(openIdsProp),
      _useState2 = _slicedToArray(_useState, 2),
      openIdsState = _useState2[0],
      setOpenIds = _useState2[1];

  var handleOpenChange = useRefCallback(function (newOpenIds) {
    setOpenIds(newOpenIds);
    onOpenChange && onOpenChange(newOpenIds);
  });
  var handleClick = useRefCallback(function (activeId) {
    if (collapse) {
      setOpenIds([]);
    }

    onClick && onClick(activeId);
  });

  var _usePrevProp = usePrevProp(collapse),
      _usePrevProp2 = _slicedToArray(_usePrevProp, 1),
      sameCollapse = _usePrevProp2[0];

  var _usePrevProp3 = usePrevProp(openIdsProp, shallowEqual),
      _usePrevProp4 = _slicedToArray(_usePrevProp3, 1),
      sameOpenIds = _usePrevProp4[0];

  if (!sameOpenIds) {
    setOpenIds(openIdsProp);
  }

  if (!sameCollapse) {
    setOpenIds(openIdsProp);
  }

  var cls = classnames(usePrefixCls('menu', _defineProperty({}, menuType, true)), usePrefixCls("menu-".concat(theme)), className);
  return React.createElement(RcPopper, null, React.createElement(RcMenu, Object.assign({
    openIds: openIdsState,
    collapse: collapse,
    onOpenChange: handleOpenChange,
    onClick: handleClick,
    extraProps: extraProps
  }, rest), React.createElement("div", {
    className: cls,
    style: style
  }, children)));
}
Menu.SubMenu = SubMenu;
Menu.Item = MenuItem;
Menu.ItemGroup = ItemGroup;